import { trace } from 'rytm-helpers';

const SCROLL_TO_SELECTOR = '[data-scroll-to="true"]';

export const scrollToOnPageChange = () => {
  const el = document.querySelector(SCROLL_TO_SELECTOR);
  if (el) {
    scrollTo(el);
  }
}

export const scrollTo = (el) => {
  if (!el) {
    trace('scrollTo: No element provided');
    return;
  }
  const rect = el.getBoundingClientRect();
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: rect.top + window.scrollY - 74,
  });
}